import React from "react";
import { Layout, Row, Col } from "antd";
import LayoutHeader from "screen/00_Nav/layout/layout_header";
import SectionCointaner from "component/sections/section_container";
import BailiffHeader from "./component/bailiff_header";
import BailiffSearch from "./component/bailiff_search";
import BailiffTable from "./component/bailiff_table";
import { URL } from "screen/00_Nav/url";
import TriggerInit from "./trigger/trigger_init";
//
//component
//redux
//selector
//actions
//utils
//hook

//str

const breadCrum = [
  {
    title: "Home",
    url: null,
  },
  {
    title: "Bailiff",
    url: URL.bailiff,
  },
];

const BailiffListing = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[10, 20]}>
        <Col xl={18} lg={18} md={18} xs={24}>
          <BailiffHeader />
        </Col>
        <Col align="right" xl={6} lg={6} md={6} xs={24}>
          <BailiffSearch />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <BailiffTable />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Layout id="bailiff-screen">
      <LayoutHeader title="Bailiff Listing" />
      <SectionCointaner breadCrum={breadCrum}>
        <div style={{ padding: 20 }}>
          <Row justify={"center"}>
            <Col xl={16} lg={18} md={22} xs={24}>
              {renderBody()}
            </Col>
          </Row>
        </div>
      </SectionCointaner>
      <TriggerInit />
    </Layout>
  );
};
export default BailiffListing;
